import { useRef } from "react";

const sounds = {
  new_messageNotification1: `${process.env.PUBLIC_URL}/new-message.mp3`,
  tagNotification1: `${process.env.PUBLIC_URL}/tagged-notification-2.mp3`,
  tagNotification2: `${process.env.PUBLIC_URL}/tagged-notification-1.mp3`,
  assignmentNotification1: `${process.env.PUBLIC_URL}/assignment-notification.mp3`,
  newMessage1: `${process.env.PUBLIC_URL}/new-message-notification.mp3`,
};

const volumes = {
  newMessage1: 0.7,
  tagNotification1: 0.9,
  tagNotification2: 0.9,
  assignmentNotification1: 0.9,
  new_messageNotification1: 0.7,
};

export const soundPreferences = {
  new_messageNotifications: {
    1: "new_messageNotification1",
  },
  tagNotifications: {
    1: "tagNotification1",
    2: "tagNotification2",
  },
  assignmentNotifications: {
    1: "assignmentNotification1",
  },
};

const useNotificationSounds = () => {
  const audioRefs = useRef({}); // Store Audio objects for each type
  const playingRefs = useRef({}); // Track if a type is currently playing

  const playSound = (type) => {
    if (!sounds[type]) {
      console.error(`Sound type "${type}" not found`);
      return;
    }

    if (!audioRefs.current[type]) {
      audioRefs.current[type] = new Audio(sounds[type]);
    }

    const audio = audioRefs.current[type];
    audio.volume = volumes[type];
    audio.loop = false;

    if (!playingRefs.current[type]) {
      playingRefs.current[type] = true;

      audio.play().catch((err) => {
        console.error(`Failed to play sound: ${err}`);
      });

      audio.onended = () => {
        playingRefs.current[type] = false;
      };
    }
  };

  return playSound;
};

export default useNotificationSounds;
